module.exports = __webpack_public_path__ + "img/add_header.0ad78bec.svg";